<template>
    <div :class="classes" role="image" :style="style"/>
</template>
<script>
export default {
    name: 'SkeletonImage',
    props: {
        height: {
            type: Number,
            default: 400,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        style () {
            const style = {};

            if (this.height) {
                style.height = `${this.height}px`;
            }

            return style;
        },
        classes () {
            return {
                skeleton: true,
                image: true,
                rounded: this.rounded,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

.skeleton.image {
    height: 400px;
    min-width: 180px;

    &:not(.rounded) {
        border-radius: unset;
    }
}
</style>
